import React from "react";

export const YouTubeSection = ({ videos }) => {
  return (
    <section id="youtube-videos" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Testimonios en YouTube</h2>
        </div>
        <div className="row justify-content-center">
          {videos.map((videoId, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="video-responsive">
                <iframe
                  width="100%"
                  height="250"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ marginBottom: 10 }}
                ></iframe>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
